import * as React from 'react'
import { Link, LinkProps } from 'react-router-dom'
import { LocationDescriptor } from 'history'
import { ReactComponent as ArrowBackIcon } from '../../assets/v3/icons/arrow-back.svg'
import './YumBack.scss'

interface YumBackProps extends LinkProps {
  to: LocationDescriptor
}

const YumBack = ({ to, ...props }: YumBackProps) => {
  return (
    <Link className="yum-back" to={to}>
      <ArrowBackIcon />
    </Link>
  )
}

export default YumBack
